import React from "react";
import { motion } from "framer-motion";

const Badge = ({
  children,
  variant = "default",
  size = "md",
  className = "",
}) => {
  const variants = {
    default: "bg-raise text-muted",
    success: "bg-ok-soft text-ok",
    warning: "bg-warn-soft text-warn",
    danger: "bg-danger-soft text-danger",
    info: "bg-accent-soft text-accent-ink",
    primary: "bg-accent-soft text-accent-ink",
  };

  const sizes = {
    sm: "text-xs h-6 px-2.5",
    md: "text-sm px-3 py-1",
    lg: "text-base px-4 py-1.5",
  };

  return (
    <motion.span
      initial={{ scale: 0.9, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      className={`pill !h-auto justify-center capitalize ${variants[variant]} ${sizes[size]} ${className}`}
    >
      {children}
    </motion.span>
  );
};

export default Badge;
